<template>
  <tr>
    <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 border w-full">
      {{ product.name }}
    </td>
    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-right tabular-nums border">
      {{ accOrderLineItem.quantity }}
    </td>
    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 border tabular-nums text-right">
      {{ subtotal }}
    </td>
    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 border tabular-nums text-right">
      {{ total }}
    </td>
  </tr>
</template>

<script>
import numbro from '@/utils/numbro';

export default {
  props: {
    accOrderLineItem: {
      type: Object,
      required: true,
    },
  },
  computed: {
    product() {
      return this.$store.state.entities.accProducts.byId[this.accOrderLineItem.accProductId];
    },
    subtotal() {
      return numbro(this.accOrderLineItem.subtotal).formatCurrency({
        mantissa: 2,
        spaceSeparated: true,
      });
    },
    total() {
      return numbro(this.accOrderLineItem.total).formatCurrency({
        mantissa: 2,
        spaceSeparated: true,
      });
    },
  },
};
</script>
